var Kr = Object.defineProperty;
var Ur = (e, t) => {
  for (var r in t) Kr(e, r, { get: t[r], enumerable: !0 });
};
(function () {
  'use strict';
  var e = (d, y) => {
    let S = (b) => {
        for (let O = 0, { length: L } = b; O < L; O++) I(b[O]);
      },
      I = ({ target: b, attributeName: O, oldValue: L }) => {
        b.attributeChangedCallback(O, L, b.getAttribute(O));
      };
    return (b, O) => {
      let { observedAttributes: L } = b.constructor;
      return (
        L &&
          d(O).then(() => {
            new y(S).observe(b, {
              attributes: !0,
              attributeOldValue: !0,
              attributeFilter: L,
            });
            for (let z = 0, { length: x } = L; z < x; z++)
              b.hasAttribute(L[z]) && I({ target: b, attributeName: L[z], oldValue: null });
          }),
        b
      );
    };
  };
  let n = 'querySelectorAll',
    i = 'querySelectorAll',
    { document: s, Element: o, MutationObserver: c, Set: f, WeakMap: u } = self,
    v = (d) => i in d,
    { filter: h } = [];
  var m = (d) => {
    let y = new u(),
      S = (x, D) => {
        let C;
        if (D)
          for (
            let M,
              T = ((B) => B.matches || B.webkitMatchesSelector || B.msMatchesSelector)(x),
              N = 0,
              { length: J } = b;
            N < J;
            N++
          )
            T.call(x, (M = b[N])) &&
              (y.has(x) || y.set(x, new f()), (C = y.get(x)), C.has(M) || (C.add(M), d.handle(x, D, M)));
        else
          y.has(x) &&
            ((C = y.get(x)),
            y.delete(x),
            C.forEach((M) => {
              d.handle(x, D, M);
            }));
      },
      I = (x, D = !0) => {
        for (let C = 0, { length: M } = x; C < M; C++) S(x[C], D);
      },
      { query: b } = d,
      O = d.root || s,
      L = ((x, D = document, C = MutationObserver, M = ['*']) => {
        let T = (B, it, ot, at, lt, ht) => {
            for (let tt of B)
              (ht || n in tt) &&
                (lt
                  ? ot.has(tt) || (ot.add(tt), at.delete(tt), x(tt, lt))
                  : at.has(tt) || (at.add(tt), ot.delete(tt), x(tt, lt)),
                ht || T(tt[n](it), it, ot, at, lt, !0));
          },
          N = new C((B) => {
            if (M.length) {
              let it = M.join(','),
                ot = new Set(),
                at = new Set();
              for (let { addedNodes: lt, removedNodes: ht } of B) T(ht, it, ot, at, !1, !1), T(lt, it, ot, at, !0, !1);
            }
          }),
          { observe: J } = N;
        return (N.observe = (B) => J.call(N, B, { subtree: !0, childList: !0 }))(D), N;
      })(S, O, c, b),
      { attachShadow: z } = o.prototype;
    return (
      z &&
        (o.prototype.attachShadow = function (x) {
          let D = z.call(this, x);
          return L.observe(D), D;
        }),
      b.length && I(O[i](b)),
      {
        drop: (x) => {
          for (let D = 0, { length: C } = x; D < C; D++) y.delete(x[D]);
        },
        flush: () => {
          let x = L.takeRecords();
          for (let D = 0, { length: C } = x; D < C; D++)
            I(h.call(x[D].removedNodes, v), !1), I(h.call(x[D].addedNodes, v), !0);
        },
        observer: L,
        parse: I,
      }
    );
  };
  let {
      document: w,
      Map: R,
      MutationObserver: k,
      Object: P,
      Set: $,
      WeakMap: X,
      Element: K,
      HTMLElement: H,
      Node: et,
      Error: W,
      TypeError: nt,
      Reflect: _,
    } = self,
    { defineProperty: Y, keys: g, getOwnPropertyNames: l, setPrototypeOf: a } = P,
    p = !self.customElements,
    A = (d) => {
      let y = g(d),
        S = [],
        I = new $(),
        { length: b } = y;
      for (let O = 0; O < b; O++) {
        S[O] = d[y[O]];
        try {
          delete d[y[O]];
        } catch {
          I.add(O);
        }
      }
      return () => {
        for (let O = 0; O < b; O++) I.has(O) || (d[y[O]] = S[O]);
      };
    };
  if (p) {
    let M = function () {
        let { constructor: T } = this;
        if (!y.has(T)) throw new nt('Illegal constructor');
        let N = y.get(T);
        if (x) return C(x, N);
        let J = d.call(w, N);
        return C(a(J, T.prototype), N);
      },
      { createElement: d } = w,
      y = new R(),
      S = new R(),
      I = new R(),
      b = new R(),
      O = [],
      L = (T, N, J) => {
        let B = I.get(J);
        if (N && !B.isPrototypeOf(T)) {
          let ot = A(T);
          x = a(T, B);
          try {
            new B.constructor();
          } finally {
            (x = null), ot();
          }
        }
        let it = (N ? '' : 'dis') + 'connectedCallback';
        it in B && T[it]();
      },
      { parse: z } = m({ query: O, handle: L }),
      x = null,
      D = (T) => {
        if (!S.has(T)) {
          let N,
            J = new Promise((B) => {
              N = B;
            });
          S.set(T, { $: J, _: N });
        }
        return S.get(T).$;
      },
      C = e(D, k);
    (self.customElements = {
      define: (T, N) => {
        if (b.has(T)) throw new W(`the name "${T}" has already been used with this registry`);
        y.set(N, T),
          I.set(T, N.prototype),
          b.set(T, N),
          O.push(T),
          D(T).then(() => {
            z(w.querySelectorAll(T));
          }),
          S.get(T)._(N);
      },
      get: (T) => b.get(T),
      whenDefined: D,
    }),
      Y((M.prototype = H.prototype), 'constructor', { value: M }),
      (self.HTMLElement = M),
      (w.createElement = function (T, N) {
        let J = N && N.is,
          B = J ? b.get(J) : b.get(T);
        return B ? new B() : d.call(w, T);
      }),
      'isConnected' in et.prototype ||
        Y(et.prototype, 'isConnected', {
          configurable: !0,
          get() {
            return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED);
          },
        });
  } else if (((p = !self.customElements.get('extends-br')), p))
    try {
      let d = function () {
        return self.Reflect.construct(HTMLBRElement, [], d);
      };
      d.prototype = HTMLLIElement.prototype;
      let y = 'extends-br';
      self.customElements.define('extends-br', d, { extends: 'br' }),
        (p = w.createElement('br', { is: y }).outerHTML.indexOf(y) < 0);
      let { get: S, whenDefined: I } = self.customElements;
      self.customElements.whenDefined = function (b) {
        return I.call(this, b).then((O) => O || S.call(this, b));
      };
    } catch {}
  if (p) {
    let We = function (E) {
        let F = L.get(E);
        it(F.querySelectorAll(this), E.isConnected);
      },
      d = self.customElements,
      { createElement: y } = w,
      { define: S, get: I, upgrade: b } = d,
      { construct: O } = _ || {
        construct(E) {
          return E.call(this);
        },
      },
      L = new X(),
      z = new $(),
      x = new R(),
      D = new R(),
      C = new R(),
      M = new R(),
      T = [],
      N = [],
      J = (E) => M.get(E) || I.call(d, E),
      B = (E, F, U) => {
        let j = C.get(U);
        if (F && !j.isPrototypeOf(E)) {
          let ge = A(E);
          tt = a(E, j);
          try {
            new j.constructor();
          } finally {
            (tt = null), ge();
          }
        }
        let G = (F ? '' : 'dis') + 'connectedCallback';
        G in j && E[G]();
      },
      { parse: it } = m({ query: N, handle: B }),
      { parse: ot } = m({
        query: T,
        handle(E, F) {
          L.has(E) && (F ? z.add(E) : z.delete(E), N.length && We.call(N, E));
        },
      }),
      { attachShadow: at } = K.prototype;
    at &&
      (K.prototype.attachShadow = function (E) {
        let F = at.call(this, E);
        return L.set(this, F), F;
      });
    let lt = (E) => {
        if (!D.has(E)) {
          let F,
            U = new Promise((j) => {
              F = j;
            });
          D.set(E, { $: U, _: F });
        }
        return D.get(E).$;
      },
      ht = e(lt, k),
      tt = null;
    l(self)
      .filter((E) => /^HTML.*Element$/.test(E))
      .forEach((E) => {
        let F = self[E];
        function U() {
          let { constructor: j } = this;
          if (!x.has(j)) throw new nt('Illegal constructor');
          let { is: G, tag: ge } = x.get(j);
          if (G) {
            if (tt) return ht(tt, G);
            let Be = y.call(w, ge);
            return Be.setAttribute('is', G), ht(a(Be, j.prototype), G);
          }
          return O.call(this, F, [], j);
        }
        a(U, F), Y((U.prototype = F.prototype), 'constructor', { value: U }), Y(self, E, { value: U });
      }),
      (w.createElement = function (E, F) {
        let U = F && F.is;
        if (U) {
          let G = M.get(U);
          if (G && x.get(G).tag === E) return new G();
        }
        let j = y.call(w, E);
        return U && j.setAttribute('is', U), j;
      }),
      (d.get = J),
      (d.whenDefined = lt),
      (d.upgrade = function (E) {
        let F = E.getAttribute('is');
        if (F) {
          let U = M.get(F);
          if (U) return void ht(a(E, U.prototype), F);
        }
        b.call(d, E);
      }),
      (d.define = function (E, F, U) {
        if (J(E)) throw new W(`'${E}' has already been defined as a custom element`);
        let j,
          G = U && U.extends;
        x.set(F, G ? { is: E, tag: G } : { is: '', tag: E }),
          G
            ? ((j = `${G}[is="${E}"]`), C.set(j, F.prototype), M.set(E, F), N.push(j))
            : (S.apply(d, arguments), T.push((j = E))),
          lt(E).then(() => {
            G ? (it(w.querySelectorAll(j)), z.forEach(We, [j])) : ot(w.querySelectorAll(j));
          }),
          D.get(E)._(F);
      });
  }
})();
var qt = null,
  He,
  Ke,
  Ue,
  qe = 65,
  ye,
  Dt,
  Ve = new Set(),
  $e = 1111;
qr();
function qr() {
  if (!document.createElement('link').relList.supports('prefetch')) return;
  let t = 'instantVaryAccept' in document.body.dataset || 'Shopify' in window,
    r = navigator.userAgent.indexOf('Chrome/');
  if ((r > -1 && (qt = parseInt(navigator.userAgent.substring(r + 7))), t && qt && qt < 110)) return;
  let n = 'instantMousedownShortcut' in document.body.dataset;
  (He = 'instantAllowQueryString' in document.body.dataset),
    (Ke = 'instantAllowExternalLinks' in document.body.dataset),
    (Ue = 'instantWhitelist' in document.body.dataset);
  let i = { capture: !0, passive: !0 },
    s = !1,
    o = !1,
    c = !1;
  if ('instantIntensity' in document.body.dataset) {
    let f = document.body.dataset.instantIntensity;
    if (f.startsWith('mousedown')) (s = !0), f == 'mousedown-only' && (o = !0);
    else if (f.startsWith('viewport')) {
      let u = navigator.connection && navigator.connection.saveData,
        v =
          navigator.connection &&
          navigator.connection.effectiveType &&
          navigator.connection.effectiveType.includes('2g');
      !u &&
        !v &&
        (f == 'viewport'
          ? document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4 && (c = !0)
          : f == 'viewport-all' && (c = !0));
    } else {
      let u = parseInt(f);
      isNaN(u) || (qe = u);
    }
  }
  if (
    (o || document.addEventListener('touchstart', $r, i),
    s ? n || document.addEventListener('mousedown', Zr, i) : document.addEventListener('mouseover', Gr, i),
    n && document.addEventListener('mousedown', Yr, i),
    c)
  ) {
    let f = window.requestIdleCallback;
    f ||
      (f = (u) => {
        u();
      }),
      f(
        function () {
          let v = new IntersectionObserver((h) => {
            h.forEach((m) => {
              if (m.isIntersecting) {
                let w = m.target;
                v.unobserve(w), Gt(w.href);
              }
            });
          });
          document.querySelectorAll('a').forEach((h) => {
            $t(h) && v.observe(h);
          });
        },
        { timeout: 1500 }
      );
  }
}
function $r(e) {
  ye = performance.now();
  let t = e.target.closest('a');
  $t(t) && Gt(t.href, 'high');
}
function Gr(e) {
  if (performance.now() - ye < $e || !('closest' in e.target)) return;
  let t = e.target.closest('a');
  $t(t) &&
    (t.addEventListener('mouseout', Xr, { passive: !0 }),
    (Dt = setTimeout(() => {
      Gt(t.href, 'high'), (Dt = void 0);
    }, qe)));
}
function Zr(e) {
  let t = e.target.closest('a');
  $t(t) && Gt(t.href, 'high');
}
function Xr(e) {
  (e.relatedTarget && e.target.closest('a') == e.relatedTarget.closest('a')) ||
    (Dt && (clearTimeout(Dt), (Dt = void 0)));
}
function Yr(e) {
  if (performance.now() - ye < $e) return;
  let t = e.target.closest('a');
  if (e.which > 1 || e.metaKey || e.ctrlKey || !t) return;
  t.addEventListener(
    'click',
    function (n) {
      n.detail != 1337 && n.preventDefault();
    },
    { capture: !0, passive: !1, once: !0 }
  );
  let r = new MouseEvent('click', {
    view: window,
    bubbles: !0,
    cancelable: !1,
    detail: 1337,
  });
  t.dispatchEvent(r);
}
function $t(e) {
  if (
    !(!e || !e.href) &&
    !(Ue && !('instant' in e.dataset)) &&
    !(e.origin != location.origin && (!(Ke || 'instant' in e.dataset) || !qt)) &&
    ['http:', 'https:'].includes(e.protocol) &&
    !(e.protocol == 'http:' && location.protocol == 'https:') &&
    !(!He && e.search && !('instant' in e.dataset)) &&
    !(e.hash && e.pathname + e.search == location.pathname + location.search) &&
    !('noInstant' in e.dataset)
  )
    return !0;
}
function Gt(e, t = 'auto') {
  if (Ve.has(e)) return;
  let r = document.createElement('link');
  (r.rel = 'prefetch'),
    (r.href = e),
    (r.fetchPriority = t),
    (r.as = 'document'),
    document.head.appendChild(r),
    Ve.add(e);
}
var focusTrapFunc = {};
Ur(focusTrapFunc, { createFocusTrap: () => xn });
var Ze = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])',
  ],
  Zt = Ze.join(','),
  Xe = typeof Element > 'u',
  Et = Xe
    ? function () {}
    : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  Xt =
    !Xe && Element.prototype.getRootNode
      ? function (e) {
          var t;
          return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
        }
      : function (e) {
          return e?.ownerDocument;
        },
  Yt = function e(t, r) {
    var n;
    r === void 0 && (r = !0);
    var i = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, 'inert'),
      s = i === '' || i === 'true',
      o = s || (r && t && e(t.parentNode));
    return o;
  },
  Qr = function (t) {
    var r,
      n = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, 'contenteditable');
    return n === '' || n === 'true';
  },
  Ye = function (t, r, n) {
    if (Yt(t)) return [];
    var i = Array.prototype.slice.apply(t.querySelectorAll(Zt));
    return r && Et.call(t, Zt) && i.unshift(t), (i = i.filter(n)), i;
  },
  Qe = function e(t, r, n) {
    for (var i = [], s = Array.from(t); s.length; ) {
      var o = s.shift();
      if (!Yt(o, !1))
        if (o.tagName === 'SLOT') {
          var c = o.assignedElements(),
            f = c.length ? c : o.children,
            u = e(f, !0, n);
          n.flatten ? i.push.apply(i, u) : i.push({ scopeParent: o, candidates: u });
        } else {
          var v = Et.call(o, Zt);
          v && n.filter(o) && (r || !t.includes(o)) && i.push(o);
          var h = o.shadowRoot || (typeof n.getShadowRoot == 'function' && n.getShadowRoot(o)),
            m = !Yt(h, !1) && (!n.shadowRootFilter || n.shadowRootFilter(o));
          if (h && m) {
            var w = e(h === !0 ? o.children : h.children, !0, n);
            n.flatten ? i.push.apply(i, w) : i.push({ scopeParent: o, candidates: w });
          } else s.unshift.apply(s, o.children);
        }
    }
    return i;
  },
  Je = function (t) {
    return !isNaN(parseInt(t.getAttribute('tabindex'), 10));
  },
  pt = function (t) {
    if (!t) throw new Error('No node provided');
    return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Qr(t)) && !Je(t) ? 0 : t.tabIndex;
  },
  Jr = function (t, r) {
    var n = pt(t);
    return n < 0 && r && !Je(t) ? 0 : n;
  },
  tn = function (t, r) {
    return t.tabIndex === r.tabIndex ? t.documentOrder - r.documentOrder : t.tabIndex - r.tabIndex;
  },
  tr = function (t) {
    return t.tagName === 'INPUT';
  },
  en = function (t) {
    return tr(t) && t.type === 'hidden';
  },
  rn = function (t) {
    var r =
      t.tagName === 'DETAILS' &&
      Array.prototype.slice.apply(t.children).some(function (n) {
        return n.tagName === 'SUMMARY';
      });
    return r;
  },
  nn = function (t, r) {
    for (var n = 0; n < t.length; n++) if (t[n].checked && t[n].form === r) return t[n];
  },
  on = function (t) {
    if (!t.name) return !0;
    var r = t.form || Xt(t),
      n = function (c) {
        return r.querySelectorAll('input[type="radio"][name="' + c + '"]');
      },
      i;
    if (typeof window < 'u' && typeof window.CSS < 'u' && typeof window.CSS.escape == 'function')
      i = n(window.CSS.escape(t.name));
    else
      try {
        i = n(t.name);
      } catch (o) {
        return (
          console.error(
            'Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s',
            o.message
          ),
          !1
        );
      }
    var s = nn(i, t.form);
    return !s || s === t;
  },
  sn = function (t) {
    return tr(t) && t.type === 'radio';
  },
  an = function (t) {
    return sn(t) && !on(t);
  },
  ln = function (t) {
    var r,
      n = t && Xt(t),
      i = (r = n) === null || r === void 0 ? void 0 : r.host,
      s = !1;
    if (n && n !== t) {
      var o, c, f;
      for (
        s = !!(
          ((o = i) !== null && o !== void 0 && (c = o.ownerDocument) !== null && c !== void 0 && c.contains(i)) ||
          (t != null && (f = t.ownerDocument) !== null && f !== void 0 && f.contains(t))
        );
        !s && i;

      ) {
        var u, v, h;
        (n = Xt(i)),
          (i = (u = n) === null || u === void 0 ? void 0 : u.host),
          (s = !!((v = i) !== null && v !== void 0 && (h = v.ownerDocument) !== null && h !== void 0 && h.contains(i)));
      }
    }
    return s;
  },
  Ge = function (t) {
    var r = t.getBoundingClientRect(),
      n = r.width,
      i = r.height;
    return n === 0 && i === 0;
  },
  cn = function (t, r) {
    var n = r.displayCheck,
      i = r.getShadowRoot;
    if (getComputedStyle(t).visibility === 'hidden') return !0;
    var s = Et.call(t, 'details>summary:first-of-type'),
      o = s ? t.parentElement : t;
    if (Et.call(o, 'details:not([open]) *')) return !0;
    if (!n || n === 'full' || n === 'legacy-full') {
      if (typeof i == 'function') {
        for (var c = t; t; ) {
          var f = t.parentElement,
            u = Xt(t);
          if (f && !f.shadowRoot && i(f) === !0) return Ge(t);
          t.assignedSlot ? (t = t.assignedSlot) : !f && u !== t.ownerDocument ? (t = u.host) : (t = f);
        }
        t = c;
      }
      if (ln(t)) return !t.getClientRects().length;
      if (n !== 'legacy-full') return !0;
    } else if (n === 'non-zero-area') return Ge(t);
    return !1;
  },
  un = function (t) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
      for (var r = t.parentElement; r; ) {
        if (r.tagName === 'FIELDSET' && r.disabled) {
          for (var n = 0; n < r.children.length; n++) {
            var i = r.children.item(n);
            if (i.tagName === 'LEGEND') return Et.call(r, 'fieldset[disabled] *') ? !0 : !i.contains(t);
          }
          return !0;
        }
        r = r.parentElement;
      }
    return !1;
  },
  Qt = function (t, r) {
    return !(r.disabled || Yt(r) || en(r) || cn(r, t) || rn(r) || un(r));
  },
  be = function (t, r) {
    return !(an(r) || pt(r) < 0 || !Qt(t, r));
  },
  fn = function (t) {
    var r = parseInt(t.getAttribute('tabindex'), 10);
    return !!(isNaN(r) || r >= 0);
  },
  dn = function e(t) {
    var r = [],
      n = [];
    return (
      t.forEach(function (i, s) {
        var o = !!i.scopeParent,
          c = o ? i.scopeParent : i,
          f = Jr(c, o),
          u = o ? e(i.candidates) : c;
        f === 0
          ? o
            ? r.push.apply(r, u)
            : r.push(c)
          : n.push({
              documentOrder: s,
              tabIndex: f,
              item: i,
              isScope: o,
              content: u,
            });
      }),
      n
        .sort(tn)
        .reduce(function (i, s) {
          return s.isScope ? i.push.apply(i, s.content) : i.push(s.content), i;
        }, [])
        .concat(r)
    );
  },
  er = function (t, r) {
    r = r || {};
    var n;
    return (
      r.getShadowRoot
        ? (n = Qe([t], r.includeContainer, {
            filter: be.bind(null, r),
            flatten: !1,
            getShadowRoot: r.getShadowRoot,
            shadowRootFilter: fn,
          }))
        : (n = Ye(t, r.includeContainer, be.bind(null, r))),
      dn(n)
    );
  },
  rr = function (t, r) {
    r = r || {};
    var n;
    return (
      r.getShadowRoot
        ? (n = Qe([t], r.includeContainer, {
            filter: Qt.bind(null, r),
            flatten: !0,
            getShadowRoot: r.getShadowRoot,
          }))
        : (n = Ye(t, r.includeContainer, Qt.bind(null, r))),
      n
    );
  },
  xt = function (t, r) {
    if (((r = r || {}), !t)) throw new Error('No node provided');
    return Et.call(t, Zt) === !1 ? !1 : be(r, t);
  },
  hn = Ze.concat('iframe').join(','),
  Jt = function (t, r) {
    if (((r = r || {}), !t)) throw new Error('No node provided');
    return Et.call(t, hn) === !1 ? !1 : Qt(r, t);
  };
function nr(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t &&
      (n = n.filter(function (i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })),
      r.push.apply(r, n);
  }
  return r;
}
function ir(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2
      ? nr(Object(r), !0).forEach(function (n) {
          pn(e, n, r[n]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
      : nr(Object(r)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
        });
  }
  return e;
}
function pn(e, t, r) {
  return (
    (t = vn(t)),
    t in e
      ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[t] = r),
    e
  );
}
function mn(e, t) {
  if (typeof e != 'object' || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || 'default');
    if (typeof n != 'object') return n;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (t === 'string' ? String : Number)(e);
}
function vn(e) {
  var t = mn(e, 'string');
  return typeof t == 'symbol' ? t : String(t);
}
var or = {
    activateTrap: function (t, r) {
      if (t.length > 0) {
        var n = t[t.length - 1];
        n !== r && n.pause();
      }
      var i = t.indexOf(r);
      i === -1 || t.splice(i, 1), t.push(r);
    },
    deactivateTrap: function (t, r) {
      var n = t.indexOf(r);
      n !== -1 && t.splice(n, 1), t.length > 0 && t[t.length - 1].unpause();
    },
  },
  gn = function (t) {
    return t.tagName && t.tagName.toLowerCase() === 'input' && typeof t.select == 'function';
  },
  yn = function (t) {
    return t?.key === 'Escape' || t?.key === 'Esc' || t?.keyCode === 27;
  },
  Ft = function (t) {
    return t?.key === 'Tab' || t?.keyCode === 9;
  },
  bn = function (t) {
    return Ft(t) && !t.shiftKey;
  },
  wn = function (t) {
    return Ft(t) && t.shiftKey;
  },
  sr = function (t) {
    return setTimeout(t, 0);
  },
  ar = function (t, r) {
    var n = -1;
    return (
      t.every(function (i, s) {
        return r(i) ? ((n = s), !1) : !0;
      }),
      n
    );
  },
  Nt = function (t) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) n[i - 1] = arguments[i];
    return typeof t == 'function' ? t.apply(void 0, n) : t;
  },
  te = function (t) {
    return t.target.shadowRoot && typeof t.composedPath == 'function' ? t.composedPath()[0] : t.target;
  },
  En = [],
  xn = function (t, r) {
    var n = r?.document || document,
      i = r?.trapStack || En,
      s = ir(
        {
          returnFocusOnDeactivate: !0,
          escapeDeactivates: !0,
          delayInitialFocus: !0,
          isKeyForward: bn,
          isKeyBackward: wn,
        },
        r
      ),
      o = {
        containers: [],
        containerGroups: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        delayInitialFocusTimer: void 0,
        recentNavEvent: void 0,
      },
      c,
      f = function (l, a, p) {
        return l && l[a] !== void 0 ? l[a] : s[p || a];
      },
      u = function (l, a) {
        var p = typeof a?.composedPath == 'function' ? a.composedPath() : void 0;
        return o.containerGroups.findIndex(function (A) {
          var d = A.container,
            y = A.tabbableNodes;
          return (
            d.contains(l) ||
            p?.includes(d) ||
            y.find(function (S) {
              return S === l;
            })
          );
        });
      },
      v = function (l) {
        var a = s[l];
        if (typeof a == 'function') {
          for (var p = arguments.length, A = new Array(p > 1 ? p - 1 : 0), d = 1; d < p; d++) A[d - 1] = arguments[d];
          a = a.apply(void 0, A);
        }
        if ((a === !0 && (a = void 0), !a)) {
          if (a === void 0 || a === !1) return a;
          throw new Error('`'.concat(l, '` was specified but was not a node, or did not return a node'));
        }
        var y = a;
        if (typeof a == 'string' && ((y = n.querySelector(a)), !y))
          throw new Error('`'.concat(l, '` as selector refers to no known node'));
        return y;
      },
      h = function () {
        var l = v('initialFocus');
        if (l === !1) return !1;
        if (l === void 0 || !Jt(l, s.tabbableOptions))
          if (u(n.activeElement) >= 0) l = n.activeElement;
          else {
            var a = o.tabbableGroups[0],
              p = a && a.firstTabbableNode;
            l = p || v('fallbackFocus');
          }
        if (!l) throw new Error('Your focus-trap needs to have at least one focusable element');
        return l;
      },
      m = function () {
        if (
          ((o.containerGroups = o.containers.map(function (l) {
            var a = er(l, s.tabbableOptions),
              p = rr(l, s.tabbableOptions),
              A = a.length > 0 ? a[0] : void 0,
              d = a.length > 0 ? a[a.length - 1] : void 0,
              y = p.find(function (b) {
                return xt(b);
              }),
              S = p
                .slice()
                .reverse()
                .find(function (b) {
                  return xt(b);
                }),
              I = !!a.find(function (b) {
                return pt(b) > 0;
              });
            return {
              container: l,
              tabbableNodes: a,
              focusableNodes: p,
              posTabIndexesFound: I,
              firstTabbableNode: A,
              lastTabbableNode: d,
              firstDomTabbableNode: y,
              lastDomTabbableNode: S,
              nextTabbableNode: function (O) {
                var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0,
                  z = a.indexOf(O);
                return z < 0
                  ? L
                    ? p.slice(p.indexOf(O) + 1).find(function (x) {
                        return xt(x);
                      })
                    : p
                        .slice(0, p.indexOf(O))
                        .reverse()
                        .find(function (x) {
                          return xt(x);
                        })
                  : a[z + (L ? 1 : -1)];
              },
            };
          })),
          (o.tabbableGroups = o.containerGroups.filter(function (l) {
            return l.tabbableNodes.length > 0;
          })),
          o.tabbableGroups.length <= 0 && !v('fallbackFocus'))
        )
          throw new Error(
            'Your focus-trap must have at least one container with at least one tabbable node in it at all times'
          );
        if (
          o.containerGroups.find(function (l) {
            return l.posTabIndexesFound;
          }) &&
          o.containerGroups.length > 1
        )
          throw new Error(
            "At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps."
          );
      },
      w = function g(l) {
        if (l !== !1 && l !== n.activeElement) {
          if (!l || !l.focus) {
            g(h());
            return;
          }
          l.focus({ preventScroll: !!s.preventScroll }), (o.mostRecentlyFocusedNode = l), gn(l) && l.select();
        }
      },
      R = function (l) {
        var a = v('setReturnFocus', l);
        return a || (a === !1 ? !1 : l);
      },
      k = function (l) {
        var a = l.target,
          p = l.event,
          A = l.isBackward,
          d = A === void 0 ? !1 : A;
        (a = a || te(p)), m();
        var y = null;
        if (o.tabbableGroups.length > 0) {
          var S = u(a, p),
            I = S >= 0 ? o.containerGroups[S] : void 0;
          if (S < 0)
            d
              ? (y = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode)
              : (y = o.tabbableGroups[0].firstTabbableNode);
          else if (d) {
            var b = ar(o.tabbableGroups, function (C) {
              var M = C.firstTabbableNode;
              return a === M;
            });
            if (
              (b < 0 &&
                (I.container === a ||
                  (Jt(a, s.tabbableOptions) && !xt(a, s.tabbableOptions) && !I.nextTabbableNode(a, !1))) &&
                (b = S),
              b >= 0)
            ) {
              var O = b === 0 ? o.tabbableGroups.length - 1 : b - 1,
                L = o.tabbableGroups[O];
              y = pt(a) >= 0 ? L.lastTabbableNode : L.lastDomTabbableNode;
            } else Ft(p) || (y = I.nextTabbableNode(a, !1));
          } else {
            var z = ar(o.tabbableGroups, function (C) {
              var M = C.lastTabbableNode;
              return a === M;
            });
            if (
              (z < 0 &&
                (I.container === a ||
                  (Jt(a, s.tabbableOptions) && !xt(a, s.tabbableOptions) && !I.nextTabbableNode(a))) &&
                (z = S),
              z >= 0)
            ) {
              var x = z === o.tabbableGroups.length - 1 ? 0 : z + 1,
                D = o.tabbableGroups[x];
              y = pt(a) >= 0 ? D.firstTabbableNode : D.firstDomTabbableNode;
            } else Ft(p) || (y = I.nextTabbableNode(a));
          }
        } else y = v('fallbackFocus');
        return y;
      },
      P = function (l) {
        var a = te(l);
        if (!(u(a, l) >= 0)) {
          if (Nt(s.clickOutsideDeactivates, l)) {
            c.deactivate({ returnFocus: s.returnFocusOnDeactivate });
            return;
          }
          Nt(s.allowOutsideClick, l) || l.preventDefault();
        }
      },
      $ = function (l) {
        var a = te(l),
          p = u(a, l) >= 0;
        if (p || a instanceof Document) p && (o.mostRecentlyFocusedNode = a);
        else {
          l.stopImmediatePropagation();
          var A,
            d = !0;
          if (o.mostRecentlyFocusedNode)
            if (pt(o.mostRecentlyFocusedNode) > 0) {
              var y = u(o.mostRecentlyFocusedNode),
                S = o.containerGroups[y].tabbableNodes;
              if (S.length > 0) {
                var I = S.findIndex(function (b) {
                  return b === o.mostRecentlyFocusedNode;
                });
                I >= 0 &&
                  (s.isKeyForward(o.recentNavEvent)
                    ? I + 1 < S.length && ((A = S[I + 1]), (d = !1))
                    : I - 1 >= 0 && ((A = S[I - 1]), (d = !1)));
              }
            } else
              o.containerGroups.some(function (b) {
                return b.tabbableNodes.some(function (O) {
                  return pt(O) > 0;
                });
              }) || (d = !1);
          else d = !1;
          d &&
            (A = k({
              target: o.mostRecentlyFocusedNode,
              isBackward: s.isKeyBackward(o.recentNavEvent),
            })),
            w(A || o.mostRecentlyFocusedNode || h());
        }
        o.recentNavEvent = void 0;
      },
      X = function (l) {
        var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        o.recentNavEvent = l;
        var p = k({ event: l, isBackward: a });
        p && (Ft(l) && l.preventDefault(), w(p));
      },
      K = function (l) {
        if (yn(l) && Nt(s.escapeDeactivates, l) !== !1) {
          l.preventDefault(), c.deactivate();
          return;
        }
        (s.isKeyForward(l) || s.isKeyBackward(l)) && X(l, s.isKeyBackward(l));
      },
      H = function (l) {
        var a = te(l);
        u(a, l) >= 0 ||
          Nt(s.clickOutsideDeactivates, l) ||
          Nt(s.allowOutsideClick, l) ||
          (l.preventDefault(), l.stopImmediatePropagation());
      },
      et = function () {
        if (o.active)
          return (
            or.activateTrap(i, c),
            (o.delayInitialFocusTimer = s.delayInitialFocus
              ? sr(function () {
                  w(h());
                })
              : w(h())),
            n.addEventListener('focusin', $, !0),
            n.addEventListener('mousedown', P, { capture: !0, passive: !1 }),
            n.addEventListener('touchstart', P, { capture: !0, passive: !1 }),
            n.addEventListener('click', H, { capture: !0, passive: !1 }),
            n.addEventListener('keydown', K, { capture: !0, passive: !1 }),
            c
          );
      },
      W = function () {
        if (o.active)
          return (
            n.removeEventListener('focusin', $, !0),
            n.removeEventListener('mousedown', P, !0),
            n.removeEventListener('touchstart', P, !0),
            n.removeEventListener('click', H, !0),
            n.removeEventListener('keydown', K, !0),
            c
          );
      },
      nt = function (l) {
        var a = l.some(function (p) {
          var A = Array.from(p.removedNodes);
          return A.some(function (d) {
            return d === o.mostRecentlyFocusedNode;
          });
        });
        a && w(h());
      },
      _ = typeof window < 'u' && 'MutationObserver' in window ? new MutationObserver(nt) : void 0,
      Y = function () {
        _ &&
          (_.disconnect(),
          o.active &&
            !o.paused &&
            o.containers.map(function (l) {
              _.observe(l, { subtree: !0, childList: !0 });
            }));
      };
    return (
      (c = {
        get active() {
          return o.active;
        },
        get paused() {
          return o.paused;
        },
        activate: function (l) {
          if (o.active) return this;
          var a = f(l, 'onActivate'),
            p = f(l, 'onPostActivate'),
            A = f(l, 'checkCanFocusTrap');
          A || m(), (o.active = !0), (o.paused = !1), (o.nodeFocusedBeforeActivation = n.activeElement), a?.();
          var d = function () {
            A && m(), et(), Y(), p?.();
          };
          return A ? (A(o.containers.concat()).then(d, d), this) : (d(), this);
        },
        deactivate: function (l) {
          if (!o.active) return this;
          var a = ir(
            {
              onDeactivate: s.onDeactivate,
              onPostDeactivate: s.onPostDeactivate,
              checkCanReturnFocus: s.checkCanReturnFocus,
            },
            l
          );
          clearTimeout(o.delayInitialFocusTimer),
            (o.delayInitialFocusTimer = void 0),
            W(),
            (o.active = !1),
            (o.paused = !1),
            Y(),
            or.deactivateTrap(i, c);
          var p = f(a, 'onDeactivate'),
            A = f(a, 'onPostDeactivate'),
            d = f(a, 'checkCanReturnFocus'),
            y = f(a, 'returnFocus', 'returnFocusOnDeactivate');
          p?.();
          var S = function () {
            sr(function () {
              y && w(R(o.nodeFocusedBeforeActivation)), A?.();
            });
          };
          return y && d ? (d(R(o.nodeFocusedBeforeActivation)).then(S, S), this) : (S(), this);
        },
        pause: function (l) {
          if (o.paused || !o.active) return this;
          var a = f(l, 'onPause'),
            p = f(l, 'onPostPause');
          return (o.paused = !0), a?.(), W(), Y(), p?.(), this;
        },
        unpause: function (l) {
          if (!o.paused || !o.active) return this;
          var a = f(l, 'onUnpause'),
            p = f(l, 'onPostUnpause');
          return (o.paused = !1), a?.(), m(), et(), Y(), p?.(), this;
        },
        updateContainerElements: function (l) {
          var a = [].concat(l).filter(Boolean);
          return (
            (o.containers = a.map(function (p) {
              return typeof p == 'string' ? n.querySelector(p) : p;
            })),
            o.active && m(),
            Y(),
            this
          );
        },
      }),
      c.updateContainerElements(t),
      c
    );
  };
function we(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Ee(e, t) {
  let r = e.indexOf(t);
  r > -1 && e.splice(r, 1);
}
var Pt = (e, t, r) => Math.min(Math.max(r, e), t);
var V = { duration: 0.3, delay: 0, endDelay: 0, repeat: 0, easing: 'ease' };
var Q = (e) => typeof e == 'number';
var ct = (e) => Array.isArray(e) && !Q(e[0]);
var cr = (e, t, r) => {
  let n = t - e;
  return ((((r - e) % n) + n) % n) + e;
};
function Lt(e, t) {
  return ct(e) ? e[cr(0, e.length, t)] : e;
}
var St = (e, t, r) => -r * e + r * t + e;
var Ct = () => {},
  Z = (e) => e;
var st = (e, t, r) => (t - e === 0 ? 1 : (r - e) / (t - e));
function At(e, t) {
  let r = e[e.length - 1];
  for (let n = 1; n <= t; n++) {
    let i = st(0, t, n);
    e.push(St(r, 1, i));
  }
}
function Ot(e) {
  let t = [0];
  return At(t, e - 1), t;
}
function Rt(e, t = Ot(e.length), r = Z) {
  let n = e.length,
    i = n - t.length;
  return (
    i > 0 && At(t, i),
    (s) => {
      let o = 0;
      for (; o < n - 2 && !(s < t[o + 1]); o++);
      let c = Pt(0, 1, st(t[o], t[o + 1], s));
      return (c = Lt(r, o)(c)), St(e[o], e[o + 1], c);
    }
  );
}
var Mt = (e) => Array.isArray(e) && Q(e[0]);
var mt = (e) => typeof e == 'object' && !!e.createAnimation;
var q = (e) => typeof e == 'function';
var ut = (e) => typeof e == 'string';
var vt = { ms: (e) => e * 1e3, s: (e) => e / 1e3 };
function xe(e, t) {
  return t ? e * (1e3 / t) : 0;
}
var ur = (e, t, r) => (((1 - 3 * r + 3 * t) * e + (3 * r - 6 * t)) * e + 3 * t) * e,
  Sn = 1e-7,
  On = 12;
function Tn(e, t, r, n, i) {
  let s,
    o,
    c = 0;
  do (o = t + (r - t) / 2), (s = ur(o, n, i) - e), s > 0 ? (r = o) : (t = o);
  while (Math.abs(s) > Sn && ++c < On);
  return o;
}
function Tt(e, t, r, n) {
  if (e === t && r === n) return Z;
  let i = (s) => Tn(s, 0, 1, e, r);
  return (s) => (s === 0 || s === 1 ? s : ur(i(s), t, n));
}
var Se =
  (e, t = 'end') =>
  (r) => {
    r = t === 'end' ? Math.min(r, 0.999) : Math.max(r, 0.001);
    let n = r * e,
      i = t === 'end' ? Math.floor(n) : Math.ceil(n);
    return Pt(0, 1, i / e);
  };
var fr = {
    ease: Tt(0.25, 0.1, 0.25, 1),
    'ease-in': Tt(0.42, 0, 1, 1),
    'ease-in-out': Tt(0.42, 0, 0.58, 1),
    'ease-out': Tt(0, 0, 0.58, 1),
  },
  _n = /\((.*?)\)/;
function It(e) {
  if (q(e)) return e;
  if (Mt(e)) return Tt(...e);
  if (fr[e]) return fr[e];
  if (e.startsWith('steps')) {
    let t = _n.exec(e);
    if (t) {
      let r = t[1].split(',');
      return Se(parseFloat(r[0]), r[1].trim());
    }
  }
  return Z;
}
var ft = class {
  constructor(
    t,
    r = [0, 1],
    {
      easing: n,
      duration: i = V.duration,
      delay: s = V.delay,
      endDelay: o = V.endDelay,
      repeat: c = V.repeat,
      offset: f,
      direction: u = 'normal',
    } = {}
  ) {
    if (
      ((this.startTime = null),
      (this.rate = 1),
      (this.t = 0),
      (this.cancelTimestamp = null),
      (this.easing = Z),
      (this.duration = 0),
      (this.totalDuration = 0),
      (this.repeat = 0),
      (this.playState = 'idle'),
      (this.finished = new Promise((h, m) => {
        (this.resolve = h), (this.reject = m);
      })),
      (n = n || V.easing),
      mt(n))
    ) {
      let h = n.createAnimation(r);
      (n = h.easing), (r = h.keyframes || r), (i = h.duration || i);
    }
    (this.repeat = c), (this.easing = ct(n) ? Z : It(n)), this.updateDuration(i);
    let v = Rt(r, f, ct(n) ? n.map(It) : Z);
    (this.tick = (h) => {
      var m;
      s = s;
      let w = 0;
      this.pauseTime !== void 0 ? (w = this.pauseTime) : (w = (h - this.startTime) * this.rate),
        (this.t = w),
        (w /= 1e3),
        (w = Math.max(w - s, 0)),
        this.playState === 'finished' && this.pauseTime === void 0 && (w = this.totalDuration);
      let R = w / this.duration,
        k = Math.floor(R),
        P = R % 1;
      !P && R >= 1 && (P = 1), P === 1 && k--;
      let $ = k % 2;
      (u === 'reverse' || (u === 'alternate' && $) || (u === 'alternate-reverse' && !$)) && (P = 1 - P);
      let X = w >= this.totalDuration ? 1 : Math.min(P, 1),
        K = v(this.easing(X));
      t(K),
        this.pauseTime === void 0 && (this.playState === 'finished' || w >= this.totalDuration + o)
          ? ((this.playState = 'finished'), (m = this.resolve) === null || m === void 0 || m.call(this, K))
          : this.playState !== 'idle' && (this.frameRequestId = requestAnimationFrame(this.tick));
    }),
      this.play();
  }
  play() {
    let t = performance.now();
    (this.playState = 'running'),
      this.pauseTime !== void 0 ? (this.startTime = t - this.pauseTime) : this.startTime || (this.startTime = t),
      (this.cancelTimestamp = this.startTime),
      (this.pauseTime = void 0),
      (this.frameRequestId = requestAnimationFrame(this.tick));
  }
  pause() {
    (this.playState = 'paused'), (this.pauseTime = this.t);
  }
  finish() {
    (this.playState = 'finished'), this.tick(0);
  }
  stop() {
    var t;
    (this.playState = 'idle'),
      this.frameRequestId !== void 0 && cancelAnimationFrame(this.frameRequestId),
      (t = this.reject) === null || t === void 0 || t.call(this, !1);
  }
  cancel() {
    this.stop(), this.tick(this.cancelTimestamp);
  }
  reverse() {
    this.rate *= -1;
  }
  commitStyles() {}
  updateDuration(t) {
    (this.duration = t), (this.totalDuration = t * (this.repeat + 1));
  }
  get currentTime() {
    return this.t;
  }
  set currentTime(t) {
    this.pauseTime !== void 0 || this.rate === 0
      ? (this.pauseTime = t)
      : (this.startTime = performance.now() - t / this.rate);
  }
  get playbackRate() {
    return this.rate;
  }
  set playbackRate(t) {
    this.rate = t;
  }
};
var kt = function () {};
var zt = class {
  setAnimation(t) {
    (this.animation = t), t?.finished.then(() => this.clearAnimation()).catch(() => {});
  }
  clearAnimation() {
    this.animation = this.generator = void 0;
  }
};
var Oe = new WeakMap();
function ee(e) {
  return Oe.has(e) || Oe.set(e, { transforms: [], values: new Map() }), Oe.get(e);
}
function dr(e, t) {
  return e.has(t) || e.set(t, new zt()), e.get(t);
}
var An = ['', 'X', 'Y', 'Z'],
  In = ['translate', 'scale', 'rotate', 'skew'],
  jt = { x: 'translateX', y: 'translateY', z: 'translateZ' },
  hr = {
    syntax: '<angle>',
    initialValue: '0deg',
    toDefaultUnit: (e) => e + 'deg',
  },
  Dn = {
    translate: {
      syntax: '<length-percentage>',
      initialValue: '0px',
      toDefaultUnit: (e) => e + 'px',
    },
    rotate: hr,
    scale: { syntax: '<number>', initialValue: 1, toDefaultUnit: Z },
    skew: hr,
  },
  gt = new Map(),
  ne = (e) => `--motion-${e}`,
  re = ['x', 'y', 'z'];
In.forEach((e) => {
  An.forEach((t) => {
    re.push(e + t), gt.set(ne(e + t), Dn[e]);
  });
});
var Nn = (e, t) => re.indexOf(e) - re.indexOf(t),
  Fn = new Set(re),
  ie = (e) => Fn.has(e),
  pr = (e, t) => {
    jt[t] && (t = jt[t]);
    let { transforms: r } = ee(e);
    we(r, t), (e.style.transform = Pn(r));
  },
  Pn = (e) => e.sort(Nn).reduce(Ln, '').trim(),
  Ln = (e, t) => `${e} ${t}(var(${ne(t)}))`;
var Wt = (e) => e.startsWith('--'),
  mr = new Set();
function vr(e) {
  if (!mr.has(e)) {
    mr.add(e);
    try {
      let { syntax: t, initialValue: r } = gt.has(e) ? gt.get(e) : {};
      CSS.registerProperty({
        name: e,
        inherits: !1,
        syntax: t,
        initialValue: r,
      });
    } catch {}
  }
}
var Te = (e, t) => document.createElement('div').animate(e, t),
  gr = {
    cssRegisterProperty: () => typeof CSS < 'u' && Object.hasOwnProperty.call(CSS, 'registerProperty'),
    waapi: () => Object.hasOwnProperty.call(Element.prototype, 'animate'),
    partialKeyframes: () => {
      try {
        Te({ opacity: [1] });
      } catch {
        return !1;
      }
      return !0;
    },
    finished: () => !!Te({ opacity: [0, 1] }, { duration: 0.001 }).finished,
    linearEasing: () => {
      try {
        Te({ opacity: 0 }, { easing: 'linear(0, 1)' });
      } catch {
        return !1;
      }
      return !0;
    },
  },
  _e = {},
  yt = {};
for (let e in gr) yt[e] = () => (_e[e] === void 0 && (_e[e] = gr[e]()), _e[e]);
var Cn = 0.015,
  Rn = (e, t) => {
    let r = '',
      n = Math.round(t / Cn);
    for (let i = 0; i < n; i++) r += e(st(0, n - 1, i)) + ', ';
    return r.substring(0, r.length - 2);
  },
  Ae = (e, t) => (q(e) ? (yt.linearEasing() ? `linear(${Rn(e, t)})` : V.easing) : Mt(e) ? Mn(e) : e),
  Mn = ([e, t, r, n]) => `cubic-bezier(${e}, ${t}, ${r}, ${n})`;
function yr(e, t) {
  for (let r = 0; r < e.length; r++) e[r] === null && (e[r] = r ? e[r - 1] : t());
  return e;
}
var oe = (e) => (Array.isArray(e) ? e : [e]);
function Bt(e) {
  return jt[e] && (e = jt[e]), ie(e) ? ne(e) : e;
}
var Vt = {
  get: (e, t) => {
    t = Bt(t);
    let r = Wt(t) ? e.style.getPropertyValue(t) : getComputedStyle(e)[t];
    if (!r && r !== 0) {
      let n = gt.get(t);
      n && (r = n.initialValue);
    }
    return r;
  },
  set: (e, t, r) => {
    (t = Bt(t)), Wt(t) ? e.style.setProperty(t, r) : (e.style[t] = r);
  },
};
function se(e, t = !0) {
  if (!(!e || e.playState === 'finished'))
    try {
      e.stop ? e.stop() : (t && e.commitStyles(), e.cancel());
    } catch {}
}
function br(e, t) {
  var r;
  let n = t?.toDefaultUnit || Z,
    i = e[e.length - 1];
  if (ut(i)) {
    let s = ((r = i.match(/(-?[\d.]+)([a-z%]*)/)) === null || r === void 0 ? void 0 : r[2]) || '';
    s && (n = (o) => o + s);
  }
  return n;
}
function kn() {
  return window.__MOTION_DEV_TOOLS_RECORD;
}
function ae(e, t, r, n = {}, i) {
  let s = kn(),
    o = n.record !== !1 && s,
    c,
    {
      duration: f = V.duration,
      delay: u = V.delay,
      endDelay: v = V.endDelay,
      repeat: h = V.repeat,
      easing: m = V.easing,
      persist: w = !1,
      direction: R,
      offset: k,
      allowWebkitAcceleration: P = !1,
    } = n,
    $ = ee(e),
    X = ie(t),
    K = yt.waapi();
  X && pr(e, t);
  let H = Bt(t),
    et = dr($.values, H),
    W = gt.get(H);
  return (
    se(et.animation, !(mt(m) && et.generator) && n.record !== !1),
    () => {
      let nt = () => {
          var g, l;
          return (l = (g = Vt.get(e, H)) !== null && g !== void 0 ? g : W?.initialValue) !== null && l !== void 0
            ? l
            : 0;
        },
        _ = yr(oe(r), nt),
        Y = br(_, W);
      if (mt(m)) {
        let g = m.createAnimation(_, t !== 'opacity', nt, H, et);
        (m = g.easing), (_ = g.keyframes || _), (f = g.duration || f);
      }
      if (
        (Wt(H) && (yt.cssRegisterProperty() ? vr(H) : (K = !1)),
        X && !yt.linearEasing() && (q(m) || (ct(m) && m.some(q))) && (K = !1),
        K)
      ) {
        W && (_ = _.map((a) => (Q(a) ? W.toDefaultUnit(a) : a))),
          _.length === 1 && (!yt.partialKeyframes() || o) && _.unshift(nt());
        let g = {
          delay: vt.ms(u),
          duration: vt.ms(f),
          endDelay: vt.ms(v),
          easing: ct(m) ? void 0 : Ae(m, f),
          direction: R,
          iterations: h + 1,
          fill: 'both',
        };
        (c = e.animate(
          {
            [H]: _,
            offset: k,
            easing: ct(m) ? m.map((a) => Ae(a, f)) : void 0,
          },
          g
        )),
          c.finished ||
            (c.finished = new Promise((a, p) => {
              (c.onfinish = a), (c.oncancel = p);
            }));
        let l = _[_.length - 1];
        c.finished
          .then(() => {
            w || (Vt.set(e, H, l), c.cancel());
          })
          .catch(Ct),
          P || (c.playbackRate = 1.000001);
      } else if (i && X)
        (_ = _.map((g) => (typeof g == 'string' ? parseFloat(g) : g))),
          _.length === 1 && _.unshift(parseFloat(nt())),
          (c = new i(
            (g) => {
              Vt.set(e, H, Y ? Y(g) : g);
            },
            _,
            Object.assign(Object.assign({}, n), { duration: f, easing: m })
          ));
      else {
        let g = _[_.length - 1];
        Vt.set(e, H, W && Q(g) ? W.toDefaultUnit(g) : g);
      }
      return (
        o && s(e, t, _, { duration: f, delay: u, easing: m, repeat: h, offset: k }, 'motion-one'), et.setAnimation(c), c
      );
    }
  );
}
var le = (e, t) => (e[t] ? Object.assign(Object.assign({}, e), e[t]) : Object.assign({}, e));
function bt(e, t) {
  var r;
  return (
    typeof e == 'string'
      ? t
        ? (((r = t[e]) !== null && r !== void 0) || (t[e] = document.querySelectorAll(e)), (e = t[e]))
        : (e = document.querySelectorAll(e))
      : e instanceof Element && (e = [e]),
    Array.from(e || [])
  );
}
var zn = (e) => e(),
  _t = (e, t, r = V.duration) => new Proxy({ animations: e.map(zn).filter(Boolean), duration: r, options: t }, Wn),
  jn = (e) => e.animations[0],
  Wn = {
    get: (e, t) => {
      let r = jn(e);
      switch (t) {
        case 'duration':
          return e.duration;
        case 'currentTime':
          return vt.s(r?.[t] || 0);
        case 'playbackRate':
        case 'playState':
          return r?.[t];
        case 'finished':
          return e.finished || (e.finished = Promise.all(e.animations.map(Bn)).catch(Ct)), e.finished;
        case 'stop':
          return () => {
            e.animations.forEach((n) => se(n));
          };
        case 'forEachNative':
          return (n) => {
            e.animations.forEach((i) => n(i, e));
          };
        default:
          return typeof r?.[t] > 'u' ? void 0 : () => e.animations.forEach((n) => n[t]());
      }
    },
    set: (e, t, r) => {
      switch (t) {
        case 'currentTime':
          r = vt.ms(r);
        case 'currentTime':
        case 'playbackRate':
          for (let n = 0; n < e.animations.length; n++) e.animations[n][t] = r;
          return !0;
      }
      return !1;
    },
  },
  Bn = (e) => e.finished;
function cascadeFunc(e = 0.1, { start: t = 0, from: r = 0, easing: n } = {}) {
  return (i, s) => {
    let o = Q(r) ? r : Vn(r, s),
      c = Math.abs(o - i),
      f = e * c;
    if (n) {
      let u = s * e;
      f = It(n)(f / u) * u;
    }
    return t + f;
  };
}
function Vn(e, t) {
  if (e === 'first') return 0;
  {
    let r = t - 1;
    return e === 'last' ? r : r / 2;
  }
}
function ce(e, t, r) {
  return q(e) ? e(t, r) : e;
}
function Er(e) {
  return function (r, n, i = {}) {
    r = bt(r);
    let s = r.length;
    kt(!!s, 'No valid element provided.'), kt(!!n, 'No keyframes defined.');
    let o = [];
    for (let c = 0; c < s; c++) {
      let f = r[c];
      for (let u in n) {
        let v = le(i, u);
        v.delay = ce(v.delay, c, s);
        let h = ae(f, u, n[u], v, e);
        o.push(h);
      }
    }
    return _t(o, i, i.duration);
  };
}
var Ie = Er(ft);
function ue(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == 'function')
    for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  return r;
}
function De(e, t, r, n) {
  var i;
  return Q(t)
    ? t
    : t.startsWith('-') || t.startsWith('+')
    ? Math.max(0, e + parseFloat(t))
    : t === '<'
    ? r
    : (i = n.get(t)) !== null && i !== void 0
    ? i
    : e;
}
function Hn(e, t, r) {
  for (let n = 0; n < e.length; n++) {
    let i = e[n];
    i.at > t && i.at < r && (Ee(e, i), n--);
  }
}
function xr(e, t, r, n, i, s) {
  Hn(e, i, s);
  for (let o = 0; o < t.length; o++) e.push({ value: t[o], at: St(i, s, n[o]), easing: Lt(r, o) });
}
function Sr(e, t) {
  return e.at === t.at ? (e.value === null ? 1 : -1) : e.at - t.at;
}
function sequenceFunc(e, t = {}) {
  var r;
  let n = Kn(e, t),
    i = n.map((s) => ae(...s, ft)).filter(Boolean);
  return _t(i, t, (r = n[0]) === null || r === void 0 ? void 0 : r[3].duration);
}
function Kn(e, t = {}) {
  var { defaultOptions: r = {} } = t,
    n = ue(t, ['defaultOptions']);
  let i = [],
    s = new Map(),
    o = {},
    c = new Map(),
    f = 0,
    u = 0,
    v = 0;
  for (let h = 0; h < e.length; h++) {
    let m = e[h];
    if (ut(m)) {
      c.set(m, u);
      continue;
    } else if (!Array.isArray(m)) {
      c.set(m.name, De(u, m.at, f, c));
      continue;
    }
    let [w, R, k = {}] = m;
    k.at !== void 0 && (u = De(u, k.at, f, c));
    let P = 0,
      $ = bt(w, o),
      X = $.length;
    for (let K = 0; K < X; K++) {
      let H = $[K],
        et = Un(H, s);
      for (let W in R) {
        let nt = qn(W, et),
          _ = oe(R[W]),
          Y = le(k, W),
          { duration: g = r.duration || V.duration, easing: l = r.easing || V.easing } = Y;
        if (mt(l)) {
          kt(W === 'opacity' || _.length > 1, 'spring must be provided 2 keyframes within timeline()');
          let S = l.createAnimation(_, W !== 'opacity', () => 0, W);
          (l = S.easing), (_ = S.keyframes || _), (g = S.duration || g);
        }
        let a = ce(k.delay, K, X) || 0,
          p = u + a,
          A = p + g,
          { offset: d = Ot(_.length) } = Y;
        d.length === 1 && d[0] === 0 && (d[1] = 1);
        let y = d.length - _.length;
        y > 0 && At(d, y),
          _.length === 1 && _.unshift(null),
          xr(nt, _, l, d, p, A),
          (P = Math.max(a + g, P)),
          (v = Math.max(A, v));
      }
    }
    (f = u), (u += P);
  }
  return (
    s.forEach((h, m) => {
      for (let w in h) {
        let R = h[w];
        R.sort(Sr);
        let k = [],
          P = [],
          $ = [];
        for (let X = 0; X < R.length; X++) {
          let { at: K, value: H, easing: et } = R[X];
          k.push(H), P.push(st(0, v, K)), $.push(et || V.easing);
        }
        P[0] !== 0 && (P.unshift(0), k.unshift(k[0]), $.unshift('linear')),
          P[P.length - 1] !== 1 && (P.push(1), k.push(null)),
          i.push([
            m,
            w,
            k,
            Object.assign(
              Object.assign(Object.assign({}, r), {
                duration: v,
                easing: $,
                offset: P,
              }),
              n
            ),
          ]);
      }
    }),
    i
  );
}
function Un(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function qn(e, t) {
  return t[e] || (t[e] = []), t[e];
}
var $n = { any: 0, all: 1 };
function inViewFunc(e, t, { root: r, margin: n, amount: i = 'any' } = {}) {
  if (typeof IntersectionObserver > 'u') return () => {};
  let s = bt(e),
    o = new WeakMap(),
    c = (u) => {
      u.forEach((v) => {
        let h = o.get(v.target);
        if (v.isIntersecting !== !!h)
          if (v.isIntersecting) {
            let m = t(v);
            q(m) ? o.set(v.target, m) : f.unobserve(v.target);
          } else h && (h(v), o.delete(v.target));
      });
    },
    f = new IntersectionObserver(c, {
      root: r,
      rootMargin: n,
      threshold: typeof i == 'number' ? i : $n[i],
    });
  return s.forEach((u) => f.observe(u)), () => f.disconnect();
}
var fe = new WeakMap(),
  wt;
function Gn(e, t) {
  if (t) {
    let { inlineSize: r, blockSize: n } = t[0];
    return { width: r, height: n };
  } else
    return e instanceof SVGElement && 'getBBox' in e ? e.getBBox() : { width: e.offsetWidth, height: e.offsetHeight };
}
function Zn({ target: e, contentRect: t, borderBoxSize: r }) {
  var n;
  (n = fe.get(e)) === null ||
    n === void 0 ||
    n.forEach((i) => {
      i({
        target: e,
        contentSize: t,
        get size() {
          return Gn(e, r);
        },
      });
    });
}
function Xn(e) {
  e.forEach(Zn);
}
function Yn() {
  typeof ResizeObserver > 'u' || (wt = new ResizeObserver(Xn));
}
function _r(e, t) {
  wt || Yn();
  let r = bt(e);
  return (
    r.forEach((n) => {
      let i = fe.get(n);
      i || ((i = new Set()), fe.set(n, i)), i.add(t), wt?.observe(n);
    }),
    () => {
      r.forEach((n) => {
        let i = fe.get(n);
        i?.delete(t), i?.size || wt?.unobserve(n);
      });
    }
  );
}
var de = new Set(),
  Ht;
function Qn() {
  (Ht = () => {
    let e = { width: window.innerWidth, height: window.innerHeight },
      t = { target: window, size: e, contentSize: e };
    de.forEach((r) => r(t));
  }),
    window.addEventListener('resize', Ht);
}
function Ar(e) {
  return (
    de.add(e),
    Ht || Qn(),
    () => {
      de.delete(e), !de.size && Ht && (Ht = void 0);
    }
  );
}
function Ir(e, t) {
  return q(e) ? Ar(e) : _r(e, t);
}
var Jn = 50,
  Dr = () => ({
    current: 0,
    offset: [],
    progress: 0,
    scrollLength: 0,
    targetOffset: 0,
    targetLength: 0,
    containerLength: 0,
    velocity: 0,
  }),
  Fr = () => ({ time: 0, x: Dr(), y: Dr() }),
  ti = {
    x: { length: 'Width', position: 'Left' },
    y: { length: 'Height', position: 'Top' },
  };
function Nr(e, t, r, n) {
  let i = r[t],
    { length: s, position: o } = ti[t],
    c = i.current,
    f = r.time;
  (i.current = e['scroll' + o]),
    (i.scrollLength = e['scroll' + s] - e['client' + s]),
    (i.offset.length = 0),
    (i.offset[0] = 0),
    (i.offset[1] = i.scrollLength),
    (i.progress = st(0, i.scrollLength, i.current));
  let u = n - f;
  i.velocity = u > Jn ? 0 : xe(i.current - c, u);
}
function Pr(e, t, r) {
  Nr(e, 'x', t, r), Nr(e, 'y', t, r), (t.time = r);
}
function Lr(e, t) {
  let r = { x: 0, y: 0 },
    n = e;
  for (; n && n !== t; )
    if (n instanceof HTMLElement) (r.x += n.offsetLeft), (r.y += n.offsetTop), (n = n.offsetParent);
    else if (n instanceof SVGGraphicsElement && 'getBBox' in n) {
      let { top: i, left: s } = n.getBBox();
      for (r.x += s, r.y += i; n && n.tagName !== 'svg'; ) n = n.parentNode;
    }
  return r;
}
var scrollOffsetFunc = {
  Enter: [
    [0, 1],
    [1, 1],
  ],
  Exit: [
    [0, 0],
    [1, 0],
  ],
  Any: [
    [1, 0],
    [0, 1],
  ],
  All: [
    [0, 0],
    [1, 1],
  ],
};
var pe = { start: 0, center: 0.5, end: 1 };
function Ne(e, t, r = 0) {
  let n = 0;
  if ((pe[e] !== void 0 && (e = pe[e]), ut(e))) {
    let i = parseFloat(e);
    e.endsWith('px')
      ? (n = i)
      : e.endsWith('%')
      ? (e = i / 100)
      : e.endsWith('vw')
      ? (n = (i / 100) * document.documentElement.clientWidth)
      : e.endsWith('vh')
      ? (n = (i / 100) * document.documentElement.clientHeight)
      : (e = i);
  }
  return Q(e) && (n = t * e), r + n;
}
var ei = [0, 0];
function Cr(e, t, r, n) {
  let i = Array.isArray(e) ? e : ei,
    s = 0,
    o = 0;
  return (
    Q(e) ? (i = [e, e]) : ut(e) && ((e = e.trim()), e.includes(' ') ? (i = e.split(' ')) : (i = [e, pe[e] ? e : '0'])),
    (s = Ne(i[0], r, n)),
    (o = Ne(i[1], t)),
    s - o
  );
}
var ri = { x: 0, y: 0 };
function Rr(e, t, r) {
  let { offset: n = scrollOffsetFunc.All } = r,
    { target: i = e, axis: s = 'y' } = r,
    o = s === 'y' ? 'height' : 'width',
    c = i !== e ? Lr(i, e) : ri,
    f = i === e ? { width: e.scrollWidth, height: e.scrollHeight } : { width: i.clientWidth, height: i.clientHeight },
    u = { width: e.clientWidth, height: e.clientHeight };
  t[s].offset.length = 0;
  let v = !t[s].interpolate,
    h = n.length;
  for (let m = 0; m < h; m++) {
    let w = Cr(n[m], u[o], f[o], c[s]);
    !v && w !== t[s].interpolatorOffsets[m] && (v = !0), (t[s].offset[m] = w);
  }
  v && ((t[s].interpolate = Rt(Ot(h), t[s].offset)), (t[s].interpolatorOffsets = [...t[s].offset])),
    (t[s].progress = t[s].interpolate(t[s].current));
}
function ni(e, t = e, r) {
  if (((r.x.targetOffset = 0), (r.y.targetOffset = 0), t !== e)) {
    let n = t;
    for (; n && n != e; ) (r.x.targetOffset += n.offsetLeft), (r.y.targetOffset += n.offsetTop), (n = n.offsetParent);
  }
  (r.x.targetLength = t === e ? t.scrollWidth : t.clientWidth),
    (r.y.targetLength = t === e ? t.scrollHeight : t.clientHeight),
    (r.x.containerLength = e.clientWidth),
    (r.y.containerLength = e.clientHeight);
}
function Mr(e, t, r, n = {}) {
  let i = n.axis || 'y';
  return {
    measure: () => ni(e, n.target, r),
    update: (s) => {
      Pr(e, r, s), (n.offset || n.target) && Rr(e, r, n);
    },
    notify: q(t) ? () => t(r) : ii(t, r[i]),
  };
}
function ii(e, t) {
  return (
    e.pause(),
    e.forEachNative((r, { easing: n }) => {
      var i, s;
      if (r.updateDuration) n || (r.easing = Z), r.updateDuration(1);
      else {
        let o = { duration: 1e3 };
        n || (o.easing = 'linear'),
          (s = (i = r.effect) === null || i === void 0 ? void 0 : i.updateTiming) === null ||
            s === void 0 ||
            s.call(i, o);
      }
    }),
    () => {
      e.currentTime = t.progress;
    }
  );
}
var Kt = new WeakMap(),
  kr = new WeakMap(),
  Fe = new WeakMap(),
  zr = (e) => (e === document.documentElement ? window : e);
function scrollFunc(e, t = {}) {
  var { container: r = document.documentElement } = t,
    n = ue(t, ['container']);
  let i = Fe.get(r);
  i || ((i = new Set()), Fe.set(r, i));
  let s = Fr(),
    o = Mr(r, e, s, n);
  if ((i.add(o), !Kt.has(r))) {
    let u = () => {
      let h = performance.now();
      for (let m of i) m.measure();
      for (let m of i) m.update(h);
      for (let m of i) m.notify();
    };
    Kt.set(r, u);
    let v = zr(r);
    window.addEventListener('resize', u, { passive: !0 }),
      r !== document.documentElement && kr.set(r, Ir(r, u)),
      v.addEventListener('scroll', u, { passive: !0 });
  }
  let c = Kt.get(r),
    f = requestAnimationFrame(c);
  return () => {
    var u;
    typeof e != 'function' && e.stop(), cancelAnimationFrame(f);
    let v = Fe.get(r);
    if (!v || (v.delete(o), v.size)) return;
    let h = Kt.get(r);
    Kt.delete(r),
      h &&
        (zr(r).removeEventListener('scroll', h),
        (u = kr.get(r)) === null || u === void 0 || u(),
        window.removeEventListener('resize', h));
  };
}
function oi(e, t = {}) {
  return _t(
    [
      () => {
        let r = new ft(e, [0, 1], t);
        return r.finished.catch(() => {}), r;
      },
    ],
    t,
    t.duration
  );
}
function animateFunc(e, t, r) {
  return (q(e) ? oi : Ie)(e, t, r);
}
function dt(e) {
  (this.listenerMap = [{}, {}]),
    e && this.root(e),
    (this.handle = dt.prototype.handle.bind(this)),
    (this._removedListeners = []);
}
dt.prototype.root = function (e) {
  let t = this.listenerMap,
    r;
  if (this.rootElement) {
    for (r in t[1]) t[1].hasOwnProperty(r) && this.rootElement.removeEventListener(r, this.handle, !0);
    for (r in t[0]) t[0].hasOwnProperty(r) && this.rootElement.removeEventListener(r, this.handle, !1);
  }
  if (!e || !e.addEventListener) return this.rootElement && delete this.rootElement, this;
  this.rootElement = e;
  for (r in t[1]) t[1].hasOwnProperty(r) && this.rootElement.addEventListener(r, this.handle, !0);
  for (r in t[0]) t[0].hasOwnProperty(r) && this.rootElement.addEventListener(r, this.handle, !1);
  return this;
};
dt.prototype.captureForType = function (e) {
  return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(e) !== -1;
};
dt.prototype.on = function (e, t, r, n) {
  let i, s, o, c;
  if (!e) throw new TypeError('Invalid event type: ' + e);
  if (
    (typeof t == 'function' && ((n = r), (r = t), (t = null)),
    n === void 0 && (n = this.captureForType(e)),
    typeof r != 'function')
  )
    throw new TypeError('Handler must be a type of Function');
  return (
    (i = this.rootElement),
    (s = this.listenerMap[n ? 1 : 0]),
    s[e] || (i && i.addEventListener(e, this.handle, n), (s[e] = [])),
    t
      ? /^[a-z]+$/i.test(t)
        ? ((c = t), (o = si))
        : /^#[a-z0-9\-_]+$/i.test(t)
        ? ((c = t.slice(1)), (o = li))
        : ((c = t), (o = Element.prototype.matches))
      : ((c = null), (o = ai.bind(this))),
    s[e].push({ selector: t, handler: r, matcher: o, matcherParam: c }),
    this
  );
};
dt.prototype.off = function (e, t, r, n) {
  let i, s, o, c, f;
  if ((typeof t == 'function' && ((n = r), (r = t), (t = null)), n === void 0))
    return this.off(e, t, r, !0), this.off(e, t, r, !1), this;
  if (((o = this.listenerMap[n ? 1 : 0]), !e)) {
    for (f in o) o.hasOwnProperty(f) && this.off(f, t, r);
    return this;
  }
  if (((c = o[e]), !c || !c.length)) return this;
  for (i = c.length - 1; i >= 0; i--)
    (s = c[i]), (!t || t === s.selector) && (!r || r === s.handler) && (this._removedListeners.push(s), c.splice(i, 1));
  return c.length || (delete o[e], this.rootElement && this.rootElement.removeEventListener(e, this.handle, n)), this;
};
dt.prototype.handle = function (e) {
  let t,
    r,
    n = e.type,
    i,
    s,
    o,
    c,
    f = [],
    u,
    v = 'ftLabsDelegateIgnore';
  if (e[v] === !0) return;
  switch (
    ((u = e.target),
    u.nodeType === 3 && (u = u.parentNode),
    u.correspondingUseElement && (u = u.correspondingUseElement),
    (i = this.rootElement),
    (s = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)),
    s)
  ) {
    case 1:
      f = this.listenerMap[1][n];
      break;
    case 2:
      this.listenerMap[0] && this.listenerMap[0][n] && (f = f.concat(this.listenerMap[0][n])),
        this.listenerMap[1] && this.listenerMap[1][n] && (f = f.concat(this.listenerMap[1][n]));
      break;
    case 3:
      f = this.listenerMap[0][n];
      break;
  }
  let h = [];
  for (r = f.length; u && r; ) {
    for (t = 0; t < r && ((o = f[t]), !!o); t++)
      u.tagName &&
      ['button', 'input', 'select', 'textarea'].indexOf(u.tagName.toLowerCase()) > -1 &&
      u.hasAttribute('disabled')
        ? (h = [])
        : o.matcher.call(u, o.matcherParam, u) && h.push([e, u, o]);
    if (u === i || ((r = f.length), (u = u.parentElement || u.parentNode), u instanceof HTMLDocument)) break;
  }
  let m;
  for (t = 0; t < h.length; t++)
    if (!(this._removedListeners.indexOf(h[t][2]) > -1) && ((c = this.fire.apply(this, h[t])), c === !1)) {
      (h[t][0][v] = !0), h[t][0].preventDefault(), (m = !1);
      break;
    }
  return m;
};
dt.prototype.fire = function (e, t, r) {
  return r.handler.call(t, e, t);
};
function si(e, t) {
  return e.toLowerCase() === t.tagName.toLowerCase();
}
function ai(e, t) {
  return this.rootElement === window
    ? t === document || t === document.documentElement || t === window
    : this.rootElement === t;
}
function li(e, t) {
  return e === t.id;
}
dt.prototype.destroy = function () {
  this.off(), this.root();
};
var deletegateFunc = dt;
function Ut(e, t, r) {
  let n = document.createElement(t);
  return e && (n.className = e), r && r.appendChild(n), n;
}
function ui(e, t, r) {
  let n = `translate3d(${e}px,${t || 0}px,0)`;
  return r !== void 0 && (n += ` scale3d(${r},${r},1)`), n;
}
function Pe(e, t, r) {
  (e.style.width = typeof t == 'number' ? `${t}px` : t), (e.style.height = typeof r == 'number' ? `${r}px` : r);
}
var rt = { IDLE: 'idle', LOADING: 'loading', LOADED: 'loaded', ERROR: 'error' };
function fi(e) {
  return ('button' in e && e.button === 1) || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
function ve(e, t, r = document) {
  let n = [];
  if (e instanceof Element) n = [e];
  else if (e instanceof NodeList || Array.isArray(e)) n = Array.from(e);
  else {
    let i = typeof e == 'string' ? e : t;
    i && (n = Array.from(r.querySelectorAll(i)));
  }
  return n;
}
function di(e) {
  return typeof e == 'function' && e.prototype && e.prototype.goTo;
}
function Br() {
  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
var Le = class {
    constructor(t, r) {
      (this.type = t), (this.defaultPrevented = !1), r && Object.assign(this, r);
    }
    preventDefault() {
      this.defaultPrevented = !0;
    }
  },
  Ce = class {
    constructor() {
      (this._listeners = {}), (this._filters = {}), (this.photoswipe = void 0), (this.options = void 0);
    }
    addFilter(t, r, n = 100) {
      this._filters[t] || (this._filters[t] = []),
        this._filters[t]?.push({ fn: r, priority: n }),
        this._filters[t]?.sort((i, s) => i.priority - s.priority),
        this.photoswipe?.addFilter(t, r, n);
    }
    removeFilter(t, r) {
      this._filters[t] && (this._filters[t] = this._filters[t].filter((n) => n.fn !== r)),
        this.photoswipe && this.photoswipe.removeFilter(t, r);
    }
    applyFilters(t, ...r) {
      return (
        this._filters[t]?.forEach((n) => {
          r[0] = n.fn.apply(this, r);
        }),
        r[0]
      );
    }
    on(t, r) {
      this._listeners[t] || (this._listeners[t] = []), this._listeners[t]?.push(r), this.photoswipe?.on(t, r);
    }
    off(t, r) {
      this._listeners[t] && (this._listeners[t] = this._listeners[t].filter((n) => r !== n)),
        this.photoswipe?.off(t, r);
    }
    dispatch(t, r) {
      if (this.photoswipe) return this.photoswipe.dispatch(t, r);
      let n = new Le(t, r);
      return (
        this._listeners[t]?.forEach((i) => {
          i.call(this, n);
        }),
        n
      );
    }
  },
  Re = class {
    constructor(t, r) {
      if (((this.element = Ut('photoswipe__img photoswipe__img--placeholder', t ? 'img' : 'div', r)), t)) {
        let n = this.element;
        (n.decoding = 'async'), (n.alt = ''), (n.src = t), n.setAttribute('role', 'presentation');
      }
      this.element.setAttribute('aria-hidden', 'true');
    }
    setDisplayedSize(t, r) {
      this.element &&
        (this.element.tagName === 'IMG'
          ? (Pe(this.element, 250, 'auto'),
            (this.element.style.transformOrigin = '0 0'),
            (this.element.style.transform = ui(0, 0, t / 250)))
          : Pe(this.element, t, r));
    }
    destroy() {
      this.element?.parentNode && this.element.remove(), (this.element = null);
    }
  },
  Me = class {
    constructor(t, r, n) {
      (this.instance = r),
        (this.data = t),
        (this.index = n),
        (this.element = void 0),
        (this.placeholder = void 0),
        (this.slide = void 0),
        (this.displayedImageWidth = 0),
        (this.displayedImageHeight = 0),
        (this.width = Number(this.data.w) || Number(this.data.width) || 0),
        (this.height = Number(this.data.h) || Number(this.data.height) || 0),
        (this.isAttached = !1),
        (this.hasSlide = !1),
        (this.isDecoding = !1),
        (this.state = rt.IDLE),
        this.data.type ? (this.type = this.data.type) : this.data.src ? (this.type = 'image') : (this.type = 'html'),
        this.instance.dispatch('contentInit', { content: this });
    }
    removePlaceholder() {
      this.placeholder &&
        !this.keepPlaceholder() &&
        setTimeout(() => {
          this.placeholder && (this.placeholder.destroy(), (this.placeholder = void 0));
        }, 1e3);
    }
    load(t, r) {
      if (this.slide && this.usePlaceholder())
        if (this.placeholder) {
          let n = this.placeholder.element;
          n && !n.parentElement && this.slide.container.prepend(n);
        } else {
          let n = this.instance.applyFilters(
            'placeholderSrc',
            this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : !1,
            this
          );
          this.placeholder = new Re(n, this.slide.container);
        }
      (this.element && !r) ||
        this.instance.dispatch('contentLoad', { content: this, isLazy: t }).defaultPrevented ||
        (this.isImageContent()
          ? ((this.element = Ut('photoswipe__img', 'img')), this.displayedImageWidth && this.loadImage(t))
          : ((this.element = Ut('photoswipe__content', 'div')), (this.element.innerHTML = this.data.html || '')),
        r && this.slide && this.slide.updateContentSize(!0));
    }
    loadImage(t) {
      if (
        !this.isImageContent() ||
        !this.element ||
        this.instance.dispatch('contentLoadImage', { content: this, isLazy: t }).defaultPrevented
      )
        return;
      let r = this.element;
      this.updateSrcsetSizes(),
        this.data.srcset && (r.srcset = this.data.srcset),
        (r.src = this.data.src ?? ''),
        (r.alt = this.data.alt ?? ''),
        (this.state = rt.LOADING),
        r.complete
          ? this.onLoaded()
          : ((r.onload = () => {
              this.onLoaded();
            }),
            (r.onerror = () => {
              this.onError();
            }));
    }
    setSlide(t) {
      (this.slide = t), (this.hasSlide = !0), (this.instance = t.photoswipe);
    }
    onLoaded() {
      (this.state = rt.LOADED),
        this.slide &&
          this.element &&
          (this.instance.dispatch('loadComplete', {
            slide: this.slide,
            content: this,
          }),
          this.slide.isActive &&
            this.slide.heavyAppended &&
            !this.element.parentNode &&
            (this.append(), this.slide.updateContentSize(!0)),
          (this.state === rt.LOADED || this.state === rt.ERROR) && this.removePlaceholder());
    }
    onError() {
      (this.state = rt.ERROR),
        this.slide &&
          (this.displayError(),
          this.instance.dispatch('loadComplete', {
            slide: this.slide,
            isError: !0,
            content: this,
          }),
          this.instance.dispatch('loadError', {
            slide: this.slide,
            content: this,
          }));
    }
    isLoading() {
      return this.instance.applyFilters('isContentLoading', this.state === rt.LOADING, this);
    }
    isError() {
      return this.state === rt.ERROR;
    }
    isImageContent() {
      return this.type === 'image';
    }
    setDisplayedSize(t, r) {
      if (
        this.element &&
        (this.placeholder && this.placeholder.setDisplayedSize(t, r),
        !this.instance.dispatch('contentResize', {
          content: this,
          width: t,
          height: r,
        }).defaultPrevented && (Pe(this.element, t, r), this.isImageContent() && !this.isError()))
      ) {
        let n = !this.displayedImageWidth && t;
        (this.displayedImageWidth = t),
          (this.displayedImageHeight = r),
          n ? this.loadImage(!1) : this.updateSrcsetSizes(),
          this.slide &&
            this.instance.dispatch('imageSizeChange', {
              slide: this.slide,
              width: t,
              height: r,
              content: this,
            });
      }
    }
    isZoomable() {
      return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== rt.ERROR, this);
    }
    updateSrcsetSizes() {
      if (!this.isImageContent() || !this.element || !this.data.srcset) return;
      let t = this.element,
        r = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
      (!t.dataset.largestUsedSize || r > parseInt(t.dataset.largestUsedSize, 10)) &&
        ((t.sizes = r + 'px'), (t.dataset.largestUsedSize = String(r)));
    }
    usePlaceholder() {
      return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
    }
    lazyLoad() {
      this.instance.dispatch('contentLazyLoad', { content: this }).defaultPrevented || this.load(!0);
    }
    keepPlaceholder() {
      return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
    }
    destroy() {
      (this.hasSlide = !1),
        (this.slide = void 0),
        !this.instance.dispatch('contentDestroy', { content: this }).defaultPrevented &&
          (this.remove(),
          this.placeholder && (this.placeholder.destroy(), (this.placeholder = void 0)),
          this.isImageContent() &&
            this.element &&
            ((this.element.onload = null), (this.element.onerror = null), (this.element = void 0)));
    }
    displayError() {
      if (this.slide) {
        let t = Ut('photoswipe__error-msg', 'div');
        (t.innerText = this.instance.options?.errorMsg ?? ''),
          (t = this.instance.applyFilters('contentErrorElement', t, this)),
          (this.element = Ut('photoswipe__content photoswipe__error-msg-container', 'div')),
          this.element.appendChild(t),
          (this.slide.container.innerText = ''),
          this.slide.container.appendChild(this.element),
          this.slide.updateContentSize(!0),
          this.removePlaceholder();
      }
    }
    append() {
      if (this.isAttached || !this.element) return;
      if (((this.isAttached = !0), this.state === rt.ERROR)) {
        this.displayError();
        return;
      }
      if (this.instance.dispatch('contentAppend', { content: this }).defaultPrevented) return;
      let t = 'decode' in this.element;
      this.isImageContent()
        ? t && this.slide && (!this.slide.isActive || Br())
          ? ((this.isDecoding = !0),
            this.element
              .decode()
              .catch(() => {})
              .finally(() => {
                (this.isDecoding = !1), this.appendImage();
              }))
          : this.appendImage()
        : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
    }
    activate() {
      this.instance.dispatch('contentActivate', { content: this }).defaultPrevented ||
        !this.slide ||
        (this.isImageContent() && this.isDecoding && !Br() ? this.appendImage() : this.isError() && this.load(!1, !0),
        this.slide.holderElement && this.slide.holderElement.setAttribute('aria-hidden', 'false'));
    }
    deactivate() {
      this.instance.dispatch('contentDeactivate', { content: this }),
        this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute('aria-hidden', 'true');
    }
    remove() {
      (this.isAttached = !1),
        !this.instance.dispatch('contentRemove', { content: this }).defaultPrevented &&
          (this.element && this.element.parentNode && this.element.remove(),
          this.placeholder && this.placeholder.element && this.placeholder.element.remove());
    }
    appendImage() {
      this.isAttached &&
        (this.instance.dispatch('contentAppendImage', { content: this }).defaultPrevented ||
          (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element),
          (this.state === rt.LOADED || this.state === rt.ERROR) && this.removePlaceholder()));
    }
  };
function hi(e, t) {
  if (e.getViewportSizeFn) {
    let r = e.getViewportSizeFn(e, t);
    if (r) return r;
  }
  return { x: document.documentElement.clientWidth, y: window.innerHeight };
}
function me(e, t, r, n, i) {
  let s = 0;
  if (t.paddingFn) s = t.paddingFn(r, n, i)[e];
  else if (t.padding) s = t.padding[e];
  else {
    let o = 'padding' + e[0].toUpperCase() + e.slice(1);
    t[o] && (s = t[o]);
  }
  return Number(s) || 0;
}
function pi(e, t, r, n) {
  return {
    x: t.x - me('left', e, t, r, n) - me('right', e, t, r, n),
    y: t.y - me('top', e, t, r, n) - me('bottom', e, t, r, n),
  };
}
var Vr = 4e3,
  ke = class {
    constructor(t, r, n, i) {
      (this.photoswipe = i),
        (this.options = t),
        (this.itemData = r),
        (this.index = n),
        (this.panAreaSize = null),
        (this.elementSize = null),
        (this.fit = 1),
        (this.fill = 1),
        (this.vFill = 1),
        (this.initial = 1),
        (this.secondary = 1),
        (this.max = 1),
        (this.min = 1);
    }
    update(t, r, n) {
      let i = { x: t, y: r };
      (this.elementSize = i), (this.panAreaSize = n);
      let s = n.x / i.x,
        o = n.y / i.y;
      (this.fit = Math.min(1, s < o ? s : o)),
        (this.fill = Math.min(1, s > o ? s : o)),
        (this.vFill = Math.min(1, o)),
        (this.initial = this._getInitial()),
        (this.secondary = this._getSecondary()),
        (this.max = Math.max(this.initial, this.secondary, this._getMax())),
        (this.min = Math.min(this.fit, this.initial, this.secondary)),
        this.photoswipe &&
          this.photoswipe.dispatch('zoomLevelsUpdate', {
            zoomLevels: this,
            slideData: this.itemData,
          });
    }
    _parseZoomLevelOption(t) {
      let r = t + 'ZoomLevel',
        n = this.options[r];
      if (n) return typeof n == 'function' ? n(this) : n === 'fill' ? this.fill : n === 'fit' ? this.fit : Number(n);
    }
    _getSecondary() {
      let t = this._parseZoomLevelOption('secondary');
      return (
        t ||
        ((t = Math.min(1, this.fit * 3)),
        this.elementSize && t * this.elementSize.x > Vr && (t = Vr / this.elementSize.x),
        t)
      );
    }
    _getInitial() {
      return this._parseZoomLevelOption('initial') || this.fit;
    }
    _getMax() {
      return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
    }
  };
function Hr(e, t, r) {
  let n = t.createContentFromData(e, r),
    i,
    { options: s } = t;
  if (s) {
    i = new ke(s, e, -1);
    let o;
    t.photoswipe ? (o = t.photoswipe.viewportSize) : (o = hi(s, t));
    let c = pi(s, o, e, r);
    i.update(n.width, n.height, c);
  }
  return n.lazyLoad(), i && n.setDisplayedSize(Math.ceil(n.width * i.initial), Math.ceil(n.height * i.initial)), n;
}
function mi(e, t) {
  let r = t.getItemData(e);
  if (!t.dispatch('lazyLoadSlide', { index: e, itemData: r }).defaultPrevented) return Hr(r, t, e);
}
var ze = class extends Ce {
    getNumItems() {
      let t = 0,
        r = this.options?.dataSource;
      r && 'length' in r
        ? (t = r.length)
        : r &&
          'gallery' in r &&
          (r.items || (r.items = this._getGalleryDOMElements(r.gallery)), r.items && (t = r.items.length));
      let n = this.dispatch('numItems', { dataSource: r, numItems: t });
      return this.applyFilters('numItems', n.numItems, r);
    }
    createContentFromData(t, r) {
      return new Me(t, this, r);
    }
    getItemData(t) {
      let r = this.options?.dataSource,
        n = {};
      Array.isArray(r)
        ? (n = r[t])
        : r && 'gallery' in r && (r.items || (r.items = this._getGalleryDOMElements(r.gallery)), (n = r.items[t]));
      let i = n;
      i instanceof Element && (i = this._domElementToItemData(i));
      let s = this.dispatch('itemData', { itemData: i || {}, index: t });
      return this.applyFilters('itemData', s.itemData, t);
    }
    _getGalleryDOMElements(t) {
      return this.options?.children || this.options?.childSelector
        ? ve(this.options.children, this.options.childSelector, t) || []
        : [t];
    }
    _domElementToItemData(t) {
      let r = { element: t },
        n = t.tagName === 'A' ? t : t.querySelector('a');
      if (n) {
        (r.src = n.dataset.photoswipeSrc || n.href),
          n.dataset.photoswipeSrcset && (r.srcset = n.dataset.photoswipeSrcset),
          (r.width = n.dataset.photoswipeWidth ? parseInt(n.dataset.photoswipeWidth, 10) : 0),
          (r.height = n.dataset.photoswipeHeight ? parseInt(n.dataset.photoswipeHeight, 10) : 0),
          (r.w = r.width),
          (r.h = r.height),
          n.dataset.photoswipeType && (r.type = n.dataset.photoswipeType);
        let i = t.querySelector('img');
        i && ((r.msrc = i.currentSrc || i.src), (r.alt = i.getAttribute('alt') ?? '')),
          (n.dataset.photoswipeCropped || n.dataset.cropped) && (r.thumbCropped = !0);
      }
      return this.applyFilters('domItemData', r, t, n);
    }
    lazyLoadData(t, r) {
      return Hr(t, this, r);
    }
  },
  photoSwipeLightboxFunc = class extends ze {
    constructor(t) {
      super(),
        (this.options = t || {}),
        (this._uid = 0),
        (this.shouldOpen = !1),
        (this._preloadedContent = void 0),
        (this.onThumbnailsClick = this.onThumbnailsClick.bind(this));
    }
    init() {
      ve(this.options.gallery, this.options.gallerySelector).forEach((t) => {
        t.addEventListener('click', this.onThumbnailsClick, !1);
      });
    }
    onThumbnailsClick(t) {
      if (fi(t) || window.photoswipe) return;
      let r = { x: t.clientX, y: t.clientY };
      !r.x && !r.y && (r = null);
      let n = this.getClickedIndex(t);
      n = this.applyFilters('clickedIndex', n, t, this);
      let i = { gallery: t.currentTarget };
      n >= 0 && (t.preventDefault(), this.loadAndOpen(n, i, r));
    }
    getClickedIndex(t) {
      if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t);
      let r = t.target,
        i = ve(this.options.children, this.options.childSelector, t.currentTarget).findIndex(
          (s) => s === r || s.contains(r)
        );
      return i !== -1 ? i : this.options.children || this.options.childSelector ? -1 : 0;
    }
    loadAndOpen(t, r, n) {
      return window.photoswipe
        ? !1
        : ((this.options.index = t),
          (this.options.initialPointerPos = n),
          (this.shouldOpen = !0),
          this.preload(t, r),
          !0);
    }
    preload(t, r) {
      let { options: n } = this;
      r && (n.dataSource = r);
      let i = [],
        s = typeof n.photoswipeModule;
      if (di(n.photoswipeModule)) i.push(Promise.resolve(n.photoswipeModule));
      else {
        if (s === 'string') throw new Error('photoswipeModule as string is no longer supported');
        if (s === 'function') i.push(n.photoswipeModule());
        else throw new Error('photoswipeModule is not valid');
      }
      typeof n.openPromise == 'function' && i.push(n.openPromise()),
        n.preloadFirstSlide !== !1 && t >= 0 && (this._preloadedContent = mi(t, this));
      let o = ++this._uid;
      Promise.all(i).then((c) => {
        if (this.shouldOpen) {
          let f = c[0];
          this._openPhotoswipe(f, o);
        }
      });
    }
    _openPhotoswipe(t, r) {
      if ((r !== this._uid && this.shouldOpen) || ((this.shouldOpen = !1), window.photoswipe)) return;
      let n = typeof t == 'object' ? new t.default(this.options) : new t(this.options);
      (this.photoswipe = n),
        (window.photoswipe = n),
        Object.keys(this._listeners).forEach((i) => {
          this._listeners[i]?.forEach((s) => {
            n.on(i, s);
          });
        }),
        Object.keys(this._filters).forEach((i) => {
          this._filters[i]?.forEach((s) => {
            n.addFilter(i, s.fn, s.priority);
          });
        }),
        this._preloadedContent &&
          (n.contentLoader.addToCache(this._preloadedContent), (this._preloadedContent = void 0)),
        n.on('destroy', () => {
          (this.photoswipe = void 0), delete window.photoswipe;
        }),
        n.init();
    }
    destroy() {
      this.photoswipe?.destroy(),
        (this.shouldOpen = !1),
        (this._listeners = {}),
        ve(this.options.gallery, this.options.gallerySelector).forEach((t) => {
          t.removeEventListener('click', this.onThumbnailsClick, !1);
        });
    }
  };
(function () {
  let e = !1;
  if (
    (document.createElement('i').addEventListener('click', () => {}, {
      get signal() {
        e = !0;
      },
    }),
    e || !window.AbortController)
  )
    return;
  let t = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function (r, n, i) {
    if (i && i.signal) {
      if (i.signal.aborted) return;
      i.signal.addEventListener('abort', () => this.removeEventListener(r, n, { ...i }));
    }
    return t.call(this, r, n, i);
  };
})();
export {
  deletegateFunc as Delegate,
  focusTrapFunc as FocusTrap,
  photoSwipeLightboxFunc as PhotoSwipeLightbox,
  scrollOffsetFunc as ScrollOffset,
  animateFunc as animate,
  inViewFunc as inView,
  scrollFunc as scroll,
  cascadeFunc as cascade,
  sequenceFunc as sequence,
};
